module.exports = __webpack_public_path__ + "static/media/icon-heart-gray.5a60b9c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-heart-gray.svg
// module id = 1885
// module chunks = 0